import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "9c0dbc4c-9c09-4840-bf24-36cd575c0b23",
  raceType: "Marathon",
  title: "Pfitzinger/Douglas: 70 to 85 miles per week, 12-week schedule",
  sourceName: "Advanced Marathoning",
  sourceUrl: "https://www.amazon.com/gp/product/B07PPRH66H/ref=as_li_tl?ie=UTF8&tag=codyhoover-20&camp=1789&creative=9325&linkCode=as2&creativeASIN=B07PPRH66H&linkId=2d5713afeeff31d780b3522d13c240fd",
  units: "miles",
  workouts: [
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed\n8 miles w/ 10x100m strides"
    },
    {
      totalDistance: 12,
      description: "Medium-long run 12 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 11,
      description: "Medium-long run 11 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 17,
      description: "Marathon-pace run 17 miles w/ 8 miles @ marathon race pace"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 10,
      description: "Lactate threshold 10 miles w/ 4 miles @ 15K to half marathon race pace"
    },
    {
      totalDistance: 10,
      description: "General aerobic 10 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 12,
      description: "Medium-long run 12 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 5 miles"
    },
    {
      totalDistance: 18,
      description: "Long run 18 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 10x100m strides"
    },
    {
      totalDistance: 13,
      description: "Medium-long run 13 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 13,
      description: "Medium-long run 13 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 19,
      description: "Marathon pace run 19 miles w/10 miles @ marathon race pace"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 10,
      description: "Lactate threshold 10 miles w/ 5 miles @ 15K to half marathon race pace"
    },
    {
      totalDistance: 15,
      description: "Medium-long run 15 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 13,
      description: "Medium-long run 13 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 17,
      description: "Long run 17 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/10x100m strides"
    },
    {
      totalDistance: 15,
      description: "Medium-long run 15 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 10,
      description: "Lactate threshold 10 miles w/ 4 miles @ 15K to half marathon race pace"
    },
    {
      totalDistance: 7,
      description: "General aerobic + speed 7 miles w/ 6x100m strides"
    },
    {
      totalDistance: 18,
      description: "Long run 18 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 12,
      description: "VO₂ Max 12 miles w/ 5x1,200m @ 5K race pace; jog 50 to 90% interval time between"
    },
    {
      totalDistance: 19,
      description: "Medium-long run 15 miles a.m. Recovery 4 miles p.m."
    },
    {
      totalDistance: 10,
      description: "General aerobic 10 miles"
    },
    {
      totalDistance: 7,
      description: "Recovery + speed 7 miles w/ 6x100m strides"
    },
    {
      totalDistance: 17,
      description: "Marathon-pace run 17 miles w/ 12 miles @ marathon race pace"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 10,
      description: "General aerobic + speed 10 miles w/ 10x100m strides"
    },
    {
      totalDistance: 15,
      description: "Medium-long run 15 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 12,
      description: "Lactate threshold 12 miles w/ 7 miles @ 15K to half marathon race pace"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed8 miles w/ 6x100m strides"
    },
    {
      totalDistance: 22,
      description: "Long run 22 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 9,
      description: "VO₂ Max 9 miles w/ 5x600m @ 5K race pace; jog 50 to 90% interval time between"
    },
    {
      totalDistance: 19,
      description: "Medium-long run 15 miles a.m. Recovery 4 miles p.m."
    },
    {
      totalDistance: 7,
      description: "Recovery + speed 7 miles w/ 6x100m strides"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 13,
      description: "8K-15K tune-up race (total 9 miles to 13 miles)"
    },
    {
      totalDistance: 18,
      description: "Long run 18 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 11,
      description: "VO₂ Max 11 miles w/ 6x1,000m @ 5K race pace; jog 50 to 90% interval time between"
    },
    {
      totalDistance: 15,
      description: "Medium-long run 15 miles"
    },
    {
      totalDistance: 10,
      description: "General aerobic 10 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 6 x 100m strides"
    },
    {
      totalDistance: 20,
      description: "Long run 20 miles"
    },
    {
      totalDistance: 10,
      description: "Recovery 6 miles a.m. 4 miles p.m."
    },
    {
      totalDistance: 9,
      description: "VO₂ Max 9 miles w/ 5x600m @ 5K race pace; jog 50 to 90% interval time between"
    },
    {
      totalDistance: 12,
      description: "Medium-long run 12 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery + speed 6 miles w/ 6x100m strides"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 11,
      description: "8K-10K tune-up race (total 9 miles to 11 miles)"
    },
    {
      totalDistance: 17,
      description: "Long run 17 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 8x100m strides"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 9,
      description: "VO₂ Max 9 miles w/ 3x1,600m @ 5K race pace; jog 50 to 90% interval time between"
    },
    {
      totalDistance: 5,
      description: "Recovery 5 miles"
    },
    {
      totalDistance: 7,
      description: "Recovery + speed 7 miles w/ 10x100m strides"
    },
    {
      totalDistance: 13,
      description: "Medium-long run 13 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 7,
      description: "General aerobic 7 miles"
    },
    {
      totalDistance: 8,
      description: "Dress rehearsal 8 miles w/ 2 miles @ marathon race pace"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 5,
      description: "Recovery + speed 5 miles w/ 6x100m strides"
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles"
    },
    {
      totalDistance: 26.2,
      description: "Goal marathon 26.2mi"
    }
  ]
} as BuiltInPlan;